// Bộ sticker emoji. Mã (code) phải khớp whitelist ở BE (ChatStickerCatalog.java).
// Tin nhắn sticker: content = code, FE map ra emoji để render.
export interface ChatSticker {
  code: string;
  emoji: string;
  label: string;
}

export const CHAT_STICKERS: ChatSticker[] = [
  { code: "s_thumbsup", emoji: "👍", label: "Thích" },
  { code: "s_laugh", emoji: "😂", label: "Haha" },
  { code: "s_heart", emoji: "❤️", label: "Tim" },
  { code: "s_wow", emoji: "😮", label: "Wow" },
  { code: "s_cry", emoji: "😢", label: "Buồn" },
  { code: "s_party", emoji: "🎉", label: "Chúc mừng" },
  { code: "s_fire", emoji: "🔥", label: "Cháy" },
  { code: "s_clap", emoji: "👏", label: "Vỗ tay" },
  { code: "s_pray", emoji: "🙏", label: "Cảm ơn" },
  { code: "s_love", emoji: "😍", label: "Yêu" },
  { code: "s_cool", emoji: "😎", label: "Ngầu" },
  { code: "s_think", emoji: "🤔", label: "Suy nghĩ" },
];

const STICKER_BY_CODE = new Map(CHAT_STICKERS.map((s) => [s.code, s]));

export const getStickerEmoji = (code: string): string | undefined => STICKER_BY_CODE.get(code)?.emoji;

// Emoji để CHÈN vào ô tin nhắn (gửi chung với chữ, cỡ thường) — khác với sticker (gửi riêng, cỡ to).
export const CHAT_EMOJIS: string[] = [
  "😀", "😁", "😂", "🤣", "😊", "😍", "😘", "😎",
  "🤔", "😏", "😢", "😭", "😡", "😱", "😴", "🤗",
  "👍", "👎", "👏", "🙏", "💪", "🤝", "👌", "✌️",
  "❤️", "🔥", "🎉", "✅", "❌", "⭐", "💯", "👀",
];
